import { ValidationContext } from "~app/common/validation/validationContext";
import { ValidationErrorLevels } from "~app/common/validation/ValidationErrorLevels";
import { ValidationScopes } from "~app/common/validation/ValidationScopes";
import { IProduktvalRow } from "../../produktval/produktval.models";
import { ArbetsorderProduktvalProduktionsmallTexts } from "./arbetsorder-produktval-produktionsmall.texts";

export class ArbetsorderProduktvalProduktionsmallValidation {
    static init(mall: { benamning: string }, valdaproduktrader: IProduktvalRow[]): ValidationContext {
        const context = new ValidationContext();
        context.errorLevel = ValidationErrorLevels.error;
        context.create(ValidationScopes.spara).withRules([
            {
                errorLevel: ValidationErrorLevels.error,
                expression: () => !(mall.benamning === null || mall.benamning === undefined || mall.benamning.length === 0),
                message: { text: ArbetsorderProduktvalProduktionsmallTexts.validation.missingMallnamn },
                model: () => mall.benamning,
                name: "namnRequired"
            },
            {
                errorLevel: ValidationErrorLevels.error,
                expression: () => !(valdaproduktrader === null || valdaproduktrader === undefined || valdaproduktrader.length === 0),
                message: { text: ArbetsorderProduktvalProduktionsmallTexts.validation.missingHandelssortiment },
                model: () => valdaproduktrader,
                name: "valdaproduktraderRequired"
            }
        ]).withRulesWhen(() => (mall.benamning !== null && mall.benamning !== undefined && mall.benamning.length !== 0), [
            {
                errorLevel: ValidationErrorLevels.error,
                expression: () => mall.benamning.length <= 40,
                message: { text: ArbetsorderProduktvalProduktionsmallTexts.validation.maxLengthError },
                model: () => mall.benamning,
                name: "maxLengthError"
            }
        ]);

        return context;
    }
}
